<glxy-page>
  <glxy-empty-state>
    <glxy-empty-state-hero>
      <mat-icon>error</mat-icon>
    </glxy-empty-state-hero>
    <glxy-empty-state-title>{{ 'PAGE_NOT_FOUND.TITLE' | translate }}</glxy-empty-state-title>
    <p>{{ 'PAGE_NOT_FOUND.DESCRIPTION' | translate }}</p>
  </glxy-empty-state>
</glxy-page>
